import { ThemeProps, DefaultTheme } from 'styled-components';
import {
	GetterResponse,
	ThemeColorsTypes,
	ThemeFontsTypes,
	ThemeMediaBPTypes,
	ThemeBorderTypes,
	ThemeMediaSpaceTypes,
} from './interfaces';

export const getThemeFont = (font?: ThemeFontsTypes): GetterResponse => {
	return (props) => props.theme.fonts[font || 'sourceSansPro'];
};

export const getThemeColor = (color?: ThemeColorsTypes): GetterResponse => {
	return (props) => props.theme.colors[color || 'mineShaft'];
};

export const getThemeMedia = (bp?: ThemeMediaBPTypes): GetterResponse => {
	return (props) => props.theme.media[bp || 'xs'];
};

export const getThemeBorder = (size: ThemeBorderTypes, color: ThemeColorsTypes) => {
	return (props: ThemeProps<DefaultTheme>) => `
		${props.theme.borderWidths[size || '1']} solid ${props.theme.colors[color || 'textDarkestSubtitle']}
	`;
};

export const getThemeSpace = (space?: ThemeMediaSpaceTypes): GetterResponse => {
	return (props) => props.theme.space[space || '8'];
};
